import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { MobMaskModule } from '../shared/directives/mob-mask/mob-mask.module';
import { ApproverDeligatesComponent } from './approver-deligates/approver-deligates.component';
import { AssignApproversComponent } from './assign-approvers/assign-approvers.component';
import { AssignCustomersComponent } from './assign-customers/assign-customers.component';
import { ChildLevelsComponent } from './child-levels/child-levels.component';
import { CustomerHierarchyComponent } from './customer-hierarchy.component';
import {MatFormFieldModule} from '@angular/material/form-field';

@NgModule({
  declarations: [CustomerHierarchyComponent, ChildLevelsComponent, AssignApproversComponent, AssignCustomersComponent, ApproverDeligatesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CustomerHierarchyComponent: {
          component: CustomerHierarchyComponent,
        }
      },
    } as CmsConfig),
    MatTreeModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MobMaskModule,
    ScrollingModule
  ]
})
export class CustomerHierarchyModule { }
